import React, { useContext, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Typography } from "@mui/material";
import cx from "classnames";
import theme from "../../theme";
import colors from "../../../utils/colors";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
	root: {
		margin: "5px"
	},
	title: {
		fontSize: "24px",
		fontWeight: "bold",
		color: colors.octaBlue,
		textAlign: "center",
		[theme.breakpoints.down('md')]: {
			padding: "0 5px"
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: "18px"
		}
	},
	subTitle: {
		marginBottom: "15px",
		fontSize: "20px",
		fontWeight: "bold",
		color: colors.octaBlue
	},
	subQuestion: {
		marginBottom: "15px",
		fontSize: "16px",
		fontWeight: "bold",
		color: "#7F8EAA",
		[theme.breakpoints.down('md')]: {
			padding: "0 5px"
		}
	},
	category: {
		fontSize: "20px",
		fontWeight: "bold",
		color: colors.black
	},
	text: {
		fontSize: "16px",
		fontWeight: 300,
		color: "#7F8EAA"
	},
	label: {
		fontSize: "16px",
		fontWeight: "bold",
		color: "#7F8EAA"
	},
	value: {
		fontSize: "16px",
		fontWeight: 300,
		color: colors.octaBlue
	}
});

interface TextProps {
	type: string;
	value: string;
	customClasses?: any;
}

const Text = ({ type, value, customClasses }: TextProps) => {
	const classes = useStyles();
	const { t } = useTranslation("common");

	return (
		<Typography
			variant="body2"
			className={cx(
				{ [classes.root]: true },
				{ [customClasses]: true },
				{ [classes.title]: type === "title" },
				{ [classes.subTitle]: type === "subTitle" },
				{ [classes.subQuestion]: type === "subQuestion" },
				{ [classes.category]: type === "category" },
				{ [classes.text]: type === "text" },
				{ [classes.label]: type === "label" },
				{ [classes.value]: type === "value" }
			)}
		>
			{value}
		</Typography>
	);
};

export default Text;
